import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

interface IAlertWarning {
    msg: string
    open: boolean
    setOpen: any
}

function AlertWarning({ msg, open, setOpen }: IAlertWarning) {

    const onClose = () => {
        setOpen(false)
    }

    return (
        <>
            <Snackbar open={open} autoHideDuration={5000} onClose={onClose}>
                <Alert onClose={onClose} severity="warning">
                    {msg}
                </Alert>
            </Snackbar>
        </>
    )
}

export default AlertWarning